import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../features/home/redux/actions';
import PageDetail from '../pages/PageDetail';
import cookie from 'react-cookies';
import { getBuilderURL } from '../../../common/utils/builder-url-util';
import { findBySearchString } from '../../../common/utils/jsonUtils';
import CustomLoader from '../../common/CustomLoader';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
export class PageTab extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.projectId !== this.props.projectId) {
      this.props.actions.loadPages({ projectId: nextProps.projectId, version: nextProps.version });
    }
    return true;
  }

  componentDidMount() {
    const { projectId, actions, version } = this.props;
    if (projectId) {
      actions.loadPages({ projectId, version });
    }
  }

  state = { pagesBySearch: [], searchKey: '', showLoader: false, expandedSections: ['GENERAL'] };

  handleRefresh() {
    const { projectId, actions, version } = this.props;
    if (projectId) {
      this.setState({ showLoader: true });
      actions.loadPages({ projectId, version }).then(() => this.setState({ showLoader: false }));
    }
  }

  filterPagesBySearch = (event) => {
    const { value } = event.target;
    const { pages = [] } = this.props.home;
    const filteredPages = value ? findBySearchString('name', value, pages) : pages;
    const expandedSections = [];
    if (filteredPages.some((page) => page.isPluginPage)) expandedSections.push('SYSTEM');
    if (filteredPages.some((page) => !page.isPluginPage)) expandedSections.push('GENERAL');

    this.setState({ searchKey: value, expandedSections });
  };

  listOfPagesToShow = (pages) => {
    const { version } = this.props;
    let redirectUrl = getBuilderURL();
    let token = cookie.load('token');
    if (!token) {
      token = '';
    }
    return pages
      .sort((a, b) => {
        return a.pageIndex > b.pageIndex ? 1 : a.pageIndex == b.pageIndex ? 0 : -1;
      })
      .map((page) => (
        <PageDetail key={page.uuid} page={page} redirectUrl={redirectUrl} version={version} />
      ));
  };

  showPages = (pages) => {
    const { searchKey } = this.state;
    const filteredPages = searchKey ? findBySearchString('name', searchKey, pages) : pages;
    return filteredPages.length > 0 ? (
      this.listOfPagesToShow(filteredPages)
    ) : (
      <p style={{ fontSize: '14px', margin: '0 0 10px' }}>No matching your search.</p>
    );
  };

  renderAccordianContent = (pages) => {
    return (
      <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
        <div className="gjs-devices-c"></div>
        {this.showPages(pages)}
      </div>
    );
  };

  renderAccordion = (pages) => {
    const accordionSections = [
      {
        Id: 'SYSTEM',
        title: 'System',
        pages: pages.filter((page) => page.isPluginPage),
      },
      {
        Id: 'GENERAL',
        title: 'General',
        pages: pages.filter((page) => !page.isPluginPage),
      },
    ];
    return accordionSections.map(({ Id, title, pages }) => (
      <AccordionItem key={Id} uuid={Id}>
        <AccordionItemState>
          {({ expanded }) => (
            <>
              <AccordionItemHeading className="gjs-block-category">
                <AccordionItemButton className="gjs-title p-2">
                  <span
                    className={
                      expanded
                        ? 'gjs-caret-icon fa fa-caret-down'
                        : 'gjs-caret-icon fa fa-caret-right'
                    }
                  ></span>
                  &nbsp;
                  {title}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel className="p-0 mt-1">
                {pages.length === 0 ? (
                  <div>No pages available</div>
                ) : (
                  this.renderAccordianContent(pages)
                )}
              </AccordionItemPanel>
            </>
          )}
        </AccordionItemState>
      </AccordionItem>
    ));
  };

  render() {
    const { showLoader, searchKey, expandedSections } = this.state;
    const { pages = [] } = this.props.home;
    const totalPageCount = pages.length;
    let redirectUrl = getBuilderURL();
    let token = cookie.load('token');
    if (!token) {
      token = '';
    }
    const { projectId, version } = this.props;
    return (
      <Fragment>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color position-relative width100 border-bottom-theme">
          <div className="gjs-pn-buttons">
            <span title="Pages" className="padding-left-20">
              Pages&nbsp;
              <span
                style={{ fontSize: '12px', cursor: 'default' }}
                data-tip="Total"
                title={'Total: ' + totalPageCount}
              >
                <i className="webconnect webconnect-info-circle"></i>
              </span>
            </span>
            <span
              title="Reload Pages"
              className="gjs-pn-btn"
              style={{ display: 'flex', flexGrow: '1', justifyContent: 'end' }}
            >
              &nbsp;
              <a
                className="btn btn-theme-cancel btn-xs"
                data-tip="Reload Pages"
                data-place="bottom"
                data-effect="solid"
                onClick={() => {
                  this.handleRefresh();
                }}
              >
                <i className="wb webconnect-refresh"></i>
              </a>
            </span>
            <span title="Pages" className="">
              <a
                className="btn btn-theme-submit btn-xs"
                data-tip="Add Page"
                data-place="bottom"
                href={`${redirectUrl}editor/${version}/v/${projectId}/loader?open-modal=create-page&token=${token}`}
                data-effect="solid"
              >
                <i className="wb webconnect-plus"></i>&nbsp;Add Page
              </a>
            </span>
          </div>
          <div className="gjs-devices-c"></div>
        </div>
        <div id="blocks" className="column blocks is-abs--t-l gjs-one-bg blocks-open">
          <div className="gjs-blocks-cs gjs-one-bg gjs-two-color">
            <div className="gjs-block-categories">
              <div className="gjs-pn-panel height35 width100 position-relative">
                <div className="form-outline" style={{ padding: '10px' }}>
                  <input
                    type="search"
                    className="custom-bootstrap-form-control custom-bootstrap-form-control-sm"
                    placeholder="&#xf55c; Eg: Home"
                    style={{ fontFamily: 'Arial, Webconnect' }}
                    value={searchKey}
                    onChange={this.filterPagesBySearch}
                  />
                </div>
                {showLoader ? (
                  <CustomLoader loading={showLoader} />
                ) : (
                  <Accordion
                    key={expandedSections.join(',')}
                    allowZeroExpanded
                    preExpanded={expandedSections}
                  >
                    {this.renderAccordion(pages)}
                  </Accordion>
                )}
                <hr />
              </div>
              <div className="gjs-blocks-no-cat">
                <div className="gjs-blocks-c"></div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PageTab);
